<template>
	<div class="row">
		<div class="col-sm-11 rounded-10 py-4 mx-auto">
			<BreadCrumb name="Package" />
			<PackageCreate v-if="masterStore.state.activeComponent === 'create'" />
			<PackageTable v-if="masterStore.state.activeComponent === 'table'" />
			<CreateItinerary
				v-if="masterStore.state.activeComponent === 'itinerary'"
			/>
			<PackageShow v-if="masterStore.state.activeComponent === 'view'" />
			<PackageEdit v-if="masterStore.state.activeComponent === 'edit'" />
		</div>
	</div>
</template>
<script>
	import { inject, onBeforeUnmount, watch } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import BreadCrumb from "@/partials/MasterBreadCrumb";
	import PackageCreate from "@/components/PackageCreate";
	import PackageTable from "@/components/PackageTable";
	import CreateItinerary from "@/components/CreateItinerary";
	import PackageShow from "@/components/PackageShow";
	import PackageEdit from "@/components/PackageEdit";

	export default {
		name: "Package",
		components: {
			BreadCrumb,
			PackageCreate,
			PackageTable,
			CreateItinerary,
			PackageShow,
			PackageEdit,
		},

		setup: () => {
			const masterStore = inject("masterStore", masterStore);

			const deleteData = async (id) => {
				try {
					await API.privateRequest.delete(
						`/packages/${masterStore.state.deleteId}`,
					);
					toast.success(
						{ message: "Package Removed!", position: "topRight" },
						true,
					);
					const newStoreData = masterStore.state.data.filter(
						(item) => item._id !== id,
					);
					masterStore.methods.changeData(newStoreData);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};
			watch(
				() => masterStore.state.deleteId,
				(newDeleteId, previousDeleteId) => {
					if (!newDeleteId) return;
					deleteData(newDeleteId);
					masterStore.methods.setId("delete", previousDeleteId);
				},
			);
			onBeforeUnmount(masterStore.methods.destroy());

			return {
				deleteData,
				masterStore,
			};
		},
	};
</script>
